import React from "react";
import style from "../components-styles/Header.module.scss";

export default function Header() {
  return (
    <div className={style.header}>
      <h1>GERADOR DE CPF</h1>
    </div>
  );
}
